import { AlarmLevel } from './alarm-level';

export class ElementSettings {
    id?: string;
    mimicId: string;
    elementId: string;
    channelTag: string;
    channelIsDigital: boolean;
    activeFlags?: ActiveFlags;
    ranges?: RangeSetting[];
    disabledStatus?: DisabledStatus;
    flashingStatus?: FlashingStatus;
    toggleState?: ToggleStatus;
    buttonAction?: ButtonAction;
    elementName?: string;
    tankType?: string;
    selectNumber?: number;
    cylinderCount?: number;
    filterType?: string;
    pumpType?: string;
    valveSetting?: ValveSetting;
    elementIntegrationId: string;
}

export type Status = 0 | 1;

export class ValveSetting {
    way: string;
    orientation: string;
    percentage: number;
    percentagePositionKey: string;
    open: ValveActionSetting;
    close: ValveActionSetting;
}

export class ValveActionSetting {
    channelTag: string | null;
    channelIsDigital: boolean | null;
    state: string;
    flashEnabled: boolean;
    flashChannelTag: string | null;
}

export class Flags {
    alarm;
    cancelManual;
    cancelAuto1;
    cancelAuto2;
    cancelAuto3;
    unAck;
    disable;
}

export class ActiveFlags {
    highHigh: ActiveFlagValue;
    high: ActiveFlagValue;
    lowLow: ActiveFlagValue;
    low: ActiveFlagValue;
    over: ActiveFlagValue;
    under: ActiveFlagValue;
    outputSensorBreak: ActiveFlagValue;
    feedbackError: ActiveFlagValue;
}

export class ActiveFlagValue {
    visible: boolean;
    level: AlarmLevel;
}

export class RangeSetting {
    colorId: string;
    min: number;
    max: number;
    enabled: boolean;
}

export class StatusSetting {
    color: string;
    statusString: string;
}

export class DisabledStatus {
    channelTag: string;
    status: 0 | 1;
    enabled: boolean;
}

export class FlashingStatus {
    channelTag: string;
    color: string;
    start: 0 | 1;
    finish: 0 | 1;
    enabled: boolean;
}

export class ToggleStatus {
    active: 0 | 1;
    inactive: 0 | 1;
}

export interface BarSetting {
    scale: BarScaleType;
    interval: 0 | 1 | 2;
}

export enum BarScaleType {
    UNDEFINED = 'undefined',
    SINGLE = 'single',
    ZERO = 'zero',
}

export interface GaugeSetting {
    divisions: number;
    isCustom: boolean;
    scaleValues: number[];
    unitDisplay: boolean;
    valueDisplay: boolean;
    nameDisplay: boolean;
    title: string;
    titlePosition: GaugeTitlePosition;
}

export enum GaugeTitlePosition {
    BOTTOM = 'bottom',
    TOP = 'top',
}

export enum MimicAnimationOption {
    NONE = 'none',
    ALARM = 'alarm',
    CANCEL = 'cancel',
    UNACK = 'unack',

    ALARM_UNACK = 'alarm-unack',
    CANCEL_UNACK = 'cancel-unack',

    DIGITAL_NONE = 'digital-none',
}

export enum ButtonAction {
    Undefined = 'undefined',
    SET_CHANNEL = 'setChannel',
    TURN_ON = 'turnOn',
    TURN_OFF = 'turnOff',
    CHANGE_TO_RUN = 'changeToRun',
    CHANGE_TO_STOP = 'changeToStop',
    DISPLAY_CHANNEL = 'displayChannel',
}

export const presetColorKeys = {
    normal: { color: getColor('--mimic-normal-color') },
    ack: { color: getColor('--mimic-ack-color') },
    cancel: { color: getColor('--mimic-cancel-color') },
    bar: { color: getColor('--mimic-bar-color') },
};

function getColor(colorVar) {
    return getComputedStyle(document.body).getPropertyValue(colorVar);
}
